import { Component } from '@angular/core';
import { defaultIfEmpty, finalize, switchMap } from 'rxjs/operators';

import { PoprPriority } from '../../../shared/components/popr/popr-priority.enum';
import { PoprService } from '../../../shared/components/popr/popr.service';
import { TwoFactorComponent } from '../../../shared/components/two-factor/two-factor.component';

@Component({
  selector: 'wpro-two-factor-laboratory',
  template: `<div><button (click)="openModal()" class="fdx-c-button fdx-c-button--primary">Open 2FA Modal</button></div>`,
  styles: ['button {margin: 3em auto}', 'div {text-align: center}'],
  standalone: false
})

export class TwoFactorLaboratoryComponent {
  constructor(
    private popr: PoprService
  ) {}

  openModal(): void {
    const modal = this.popr.createModal(TwoFactorComponent);
    modal.component$().pipe(
      switchMap(comp => comp.isElevatedAuthority$()),
      defaultIfEmpty(false),
      finalize(() => modal.close())
    ).subscribe((success) => {
      this.popr.createToast(
        success ? PoprPriority.INFO : PoprPriority.ERROR,
        `2FA Status: ${success ? 'permit' : 'reject'}`);
    });
  }
}
